module.exports = __webpack_public_path__ + "img/P2051624.ad62f88e.jpg";